import { render, staticRenderFns } from "./IconOs.vue?vue&type=template&id=0312f5aa&"
import script from "./IconOs.vue?vue&type=script&lang=js&"
export * from "./IconOs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0312f5aa')) {
      api.createRecord('0312f5aa', component.options)
    } else {
      api.reload('0312f5aa', component.options)
    }
    module.hot.accept("./IconOs.vue?vue&type=template&id=0312f5aa&", function () {
      api.rerender('0312f5aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconOs.vue"
export default component.exports